import { z } from "zod";
import { AnalyticsType } from "../plugins/analytics/enums/analytics-type.enum";
import { analyticsBindEventDataSchema } from "./analytics-bind-event-data.schema";

export const analyticsDataSchema = z.object({
  type: z.nativeEnum(AnalyticsType),
  id: z.union([z.string(), z.number()]),
  bindEventsList: z.optional(analyticsBindEventDataSchema.array())
})